import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

private tokenKey = 'BearerToken'; // change to your storage key
private logoutTimer: any; // store timeout reference


  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  isTokenValid(): boolean {
    const token = this.getToken();
    if (!token) return false;

    try {
      const decoded: any = jwtDecode(token);      
      const now = Math.floor(Date.now() / 1000); // in seconds
      return decoded.exp && decoded.exp > now;
    } catch {
      return false;
    }
  }

  logout(): void {
    localStorage.removeItem(this.tokenKey);
    // optionally clear other storage keys
  }

  scheduleAutoLogout() {
     if (this.logoutTimer) {
      clearTimeout(this.logoutTimer); // ✅ prevent multiple timers
    }

    const token = this.getToken();
    if (!token) return;

    try {
      const decoded: any = jwtDecode(token);
      if (decoded.exp) {
        const expiryMs = decoded.exp * 1000 - Date.now();
        if (expiryMs > 0) {
          this.logoutTimer = setTimeout(() => this.logout(), expiryMs);
        } else {
          this.logout(); // already expired
        }
      }
    } catch {
      this.logout();
    }
  }
}
